module.exports = __webpack_public_path__ + "img/medical-square.ec3e8614.svg";